import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.dashboard';

const translations = {
    'dashboard': 'Főoldal',

    'id.title': 'Azonosító',
    'ext_id.title': 'GRoby ID',
    'email.title': 'Email',
    'name.title': 'Név',
    'totalAmount.title': 'Összeg',

    'block.users': 'Felhasználók',
    'block.orders': 'Megrendelések',
    'block.products': 'Termékek',
    'block.stats': 'Statisztika',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/lang/hu.ts